import { render, staticRenderFns } from "./subcategory.vue?vue&type=template&id=45cffc3b&"
import script from "./subcategory.vue?vue&type=script&lang=js&"
export * from "./subcategory.vue?vue&type=script&lang=js&"
import style0 from "./subcategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports